import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import axiosInstance from '@/lib/axios'
import { KpiWidget } from './KpiWidget'

export function KpiAutoCortesiaWidget() {
  const navigate = useNavigate()
  const { data, isLoading } = useQuery<number>({
    queryKey: ['dashboard', 'auto-cortesia-disponibili-count'],
    queryFn: async () => {
      const res = await axiosInstance.get('/courtesy-cars/disponibili/count')
      return res.data?.count ?? 0
    },
    staleTime: 60000,
  })
  return (
    <KpiWidget
      title="Auto cortesia disponibili"
      value={data}
      loading={isLoading}
      color={data ? '#52c41a' : '#ff4d4f'}
      onClick={() => navigate('/courtesy-cars')}
    />
  )
}
